module.exports = __webpack_public_path__ + "img/404.31dea67f.svg";